/**
 * DEV-1110 — is this tenant app a FIELD app?
 *
 * A field app is one used away from a desk and away from signal: today that is
 * Boer, a grower capturing sprays and harvest in a block with no bars. It is
 * the single signal behind two otherwise-unrelated decisions, and they must
 * agree or the app is half-configured:
 *
 *   - device enrolment (a 30-day credential is minted here and nowhere else);
 *   - the service worker's offline envelope.
 *
 * (It no longer picks the manifest's display mode: BOE-59 keeps the phone's
 * own bars on every install — see pwa/manifest.ts DISPLAY.)
 *
 * The signal is "the tenant serves the Boer module", not the tenant's slug —
 * a white-label deployment of Boer under a customer's own domain is the same
 * app with a different name, and keying on the slug would quietly exclude it.
 *
 * When a SECOND field app arrives this is the one line that changes.
 */

import type { ResolvedMfe } from "@/tenant/types";

/** Route prefixes whose presence makes a tenant app a field app. */
const FIELD_APP_PREFIXES = ["/boer"];

export function isFieldApp(modules: Pick<ResolvedMfe, "pathPrefix">[]): boolean {
  return modules.some((m) => FIELD_APP_PREFIXES.includes(m.pathPrefix));
}
